import styled from 'styled-components';

interface SidebarOpenProps {
  isSidebarOpen: boolean;
}

const NavigationWrapper = styled.div`
  display: flex;
  flex-direction: column;
  line-height: ${({ theme }) => theme.typography.body2.lineHeight};
  overflow: hidden;
  transition: margin 0.3s ease-out;
`;

const NavigationSectionsWrapper = styled.div`
  overflow-x: hidden;
  overflow-y: auto;
  padding: ${({ theme }) => theme.spacing(2)};
  ${({ theme }) => theme.spacing(1.5)};
`;

const SectionTitle = styled.div<SidebarOpenProps>`
  color: ${({ theme }) => theme.palette.grey[500]};
  font-size: ${({ theme }) => theme.typography.caption.fontSize};
  font-weight: ${({ theme }) => theme.typography.fontWeightBold};
  height: ${({ isSidebarOpen }) => (isSidebarOpen ? 'auto' : '0px')};
  letter-spacing: 0.1em;
  margin-bottom: ${({ theme }) => theme.spacing(1)};
  margin-left: ${({ theme }) => theme.spacing(1)};
  text-transform: uppercase;
  visibility: ${({ isSidebarOpen }) => (isSidebarOpen ? 'visible' : 'hidden')};
`;

const SectionWrapper = styled.div<SidebarOpenProps>`
  margin-top: ${({ theme, isSidebarOpen }) =>
    isSidebarOpen ? `${theme.spacing(3)}` : `${theme.spacing(0)}`};
`;

const StyledLink = styled.div`
  align-items: center;
  display: flex;
  width: 100%;
  &:hover,
  &:focus {
    text-decoration: none;
  }
`;

interface SidebarItemProps {
  isActive: boolean;
  isSidebarOpen: boolean;
  dataTestId?: string;
}

const SidebarItem = styled.div.attrs<SidebarItemProps>(({ dataTestId }) => ({
  'data-testid': dataTestId,
}))<SidebarItemProps>`
  align-items: center;
  background-color: ${({ theme, isActive }) =>
    isActive ? theme.palette.background.default : 'unset'};
  border-radius: 5px;
  color: ${({ isActive }) => (isActive ? 'black' : 'unset')};
  cursor: pointer;
  display: flex;
  padding-bottom: ${({ theme }) => theme.spacing(1)};
  padding-left: ${({ isSidebarOpen, theme }) =>
    isSidebarOpen ? theme.spacing(1) : theme.spacing(1.4)};
  padding-top: ${({ theme }) => theme.spacing(1)};
  width: 100%;
  &:hover,
  &:focus {
    background-color: ${({ theme }) => theme.palette.background.default};
  }
`;

const SidebarItemIcon = styled.div<SidebarOpenProps>`
  margin-right: ${({ theme, isSidebarOpen }) =>
    isSidebarOpen ? theme.spacing(1.3) : theme.spacing(3.5)};
  transition: margin-right 0.3s ease-out;
  vertical-align: middle;
`;

export {
  NavigationSectionsWrapper,
  NavigationWrapper,
  StyledLink,
  SectionTitle,
  SectionWrapper,
  SidebarItem,
  SidebarItemIcon,
};
